import { Box, Grid, TextField, Typography } from '@mui/material';
import { IDam } from '../../../services/api/dams/DamServices';

interface GeralINformationProps {
  data: IDam;
}

export const GeralINformation = ({ data }: GeralINformationProps) => {

  const formatDateForInput = (dateString: string | null | undefined): string => {
    if (!dateString) return '';

    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  };

  return (
    <Box padding={1}>
      <Box>
        <Typography variant='h5'>Informações Gerais</Typography>
      </Box>
      <Box padding={1} marginTop={1}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              inputProps={{ readOnly: true }}
              value={data?.nome}
              label='Nome do empreendimento'
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              inputProps={{ readOnly: true }}
              value={data?.proposito}
              label='Proposito'
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              inputProps={{ readOnly: true }}
              value={data?.anm}
              label='Processo minerário associado (ANM)'
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type='date'
              inputProps={{ readOnly: true }}
              value={formatDateForInput(data?.inicio_operacao)}
              label='Início da operação'
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type='date'
              inputProps={{ readOnly: true }}
              value={formatDateForInput(data?.fim_operacao)}
              label='Fim de vida útil planejado'
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};